module.exports = __webpack_public_path__ + "static/img/10.456e2f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/10.png
// module id = o0xQ
// module chunks = 0